import React from 'react';
import { Alert, Anchor, Spacer, Text } from '@zillow/constellation';
import { ICRAA_FAILED_MISSING_NAME } from '../../../../../../constants/stringConstants';
import { URLS } from '../../../../../../constants/urls';

export default function IcraaComplianceWallError({ message, ...props }) {
  if (message === ICRAA_FAILED_MISSING_NAME) {
    return (
      <Spacer {...props}>
        <Alert
          appearance="error"
          body={
            <Text>
              Your legal name is required to access this application. Please
              <Anchor href={URLS.ZILLOW_ACCOUNT_PROFILE}> visit your profile </Anchor>
              to add your legal name and return here to view the application details.
            </Text>
          }
        />
      </Spacer>
    );
  }
  return (
    <Spacer {...props}>
      <Alert appearance="error" body="Sorry, we ran into a server issue. Please try again." />
    </Spacer>
  );
}
